export enum AssessmentLogoEnum {
  STAR = 'STAR',
  FASTBRIDGE = 'FASTBRIDGE'
}
export interface Assessment {
  completedDate: string;
  districtIsProficient: boolean;
  renaissanceIsProficient: boolean;
  assessmentTimeInSeconds: number;
  subject: string;
  productId: string;
  assessmentType: string;
  percentileRank: number;
  scaledScore: number;
  currentSGP: number;
  cbmAssessmentId: string;
  cbmGradeId: string | null;
  accuracy: number;
  correctPerMinute: number;
  cbmBenchmarkCategory: string | null;
  lexile: string | null;
  benchmarkCategory: string | null;
  rachscore: number | null;
  logo: AssessmentLogoEnum | null;
  assessmentLongName: string | null;
}

export interface AssessmentDetail extends Assessment {
  teacherRenaissanceId: string
  studentRenaissanceId: string
}
